import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import 'flatpickr/dist/themes/airbnb.css';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js';
import 'flatpickr/dist/plugins/monthSelect/style.css';

window.flatpickr = flatpickr;
window.flatpickrPlugins = { monthSelect: monthSelectPlugin };

const $ = window.$;

// TODO: centralize flatpickr defaults — Sprockets-compiled pickers (orders_index.coffee, working_hours_csv_form.coffee) duplicate these manually
const defaults = {
  time_24hr: true,
  locale: { firstDayOfWeek: 1 },
};

function initFlatpickr(el, options = {}) {
  options = { ...defaults, ...options };
  if (el._flatpickr) return el._flatpickr;

  el.setAttribute('autocomplete', 'off');
  const instance = flatpickr(el, {
    ...options,
    onChange(selectedDates, dateStr, inst) {
      const oldDate = el._fp_prev_date || null;
      $(el).trigger('flatpickr:change', [selectedDates[0] || null, oldDate, dateStr]);
      el._fp_prev_date = selectedDates[0] ? new Date(selectedDates[0]) : null;
      if (options.onChange) options.onChange(selectedDates, dateStr, inst);
    },
  });

  el._fp_prev_date = instance.selectedDates[0] ? new Date(instance.selectedDates[0]) : null;
  return instance;
}

window.initFlatpickr = initFlatpickr;

$(function () {
  $('.datetimepicker, .datetimepickerwithtime, .datetimepicker-range').attr('autocomplete', 'off');
});

// Bootstrap 3's enforceFocus traps focus inside modals, which fights flatpickr's
// own focus management and causes infinite recursion. Patch it to allow flatpickr.
$(document).on('focusin.modal', (e) => {
  if ($(e.target).closest('.flatpickr-calendar').length) {
    e.stopImmediatePropagation();
  }
});

$(document)
  .on('focus', '.datetimepicker:not(.flatpickr-input)', function () {
    const isEditInPlace = !!this.closest('[data-edit-in-place="input-container"]');
    initFlatpickr(this, { dateFormat: 'Y-m-d', allowInput: true, static: isEditInPlace }).open();
  })
  .on('focus', '.datetimepicker-range:not(.flatpickr-input)', function () {
    initFlatpickr(this, {
      dateFormat: 'Y-m-d',
      allowInput: true,
      mode: 'range',
      locale: { rangeSeparator: ' - ' },
    }).open();
  })
  .on('focus', '.datetimepickerwithtime:not(.flatpickr-input)', function () {
    const el = this;
    const isEditInPlace = !!el.closest('[data-edit-in-place="input-container"]');
    const instance = initFlatpickr(el, { dateFormat: 'Y-m-d H:i', enableTime: true, static: isEditInPlace });
    setTimeout(() => instance.open(), 0);
  });
